// Company Details ********************************************************************************
// pathname: /v1/company/billing-data
// ************************************************************************************************
import { useSwrApi } from 'src/hooks/useSwrApi';


interface IProps {
  locale?: string;
  type: string;
  serverSideData?: ApiSchema<'BillingDataRead'>;
  shouldFetch?: boolean;
}

/**
 * @description SWR: fetch company details
 * @param locale - { string } - the locale to use for the request. Default: 'ro'.
 * @param type - { string } - Can be the billing information about company or individual accounts . Default: 'individual'.
 * @param serverSideData - { ApiCompanyDetails } - the data we got from the server side request (if we do it). Default undefined.
 * @param shouldFetch - { boolean } - if we should fetch the data. Default true.
 */
export const useSwrGetBilingInfoList = ({
  locale = 'ro', serverSideData, shouldFetch = true, type = 'individual',
}: IProps) => {
  // Get data from API
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'BillingDataRead'>[]>({
    url: `/v1/company/billing-info-list/${type}`,
    locale,
    serverSideData,
    shouldFetch,
    apiOptions: {
      dedupingInterval: 60 * 1000 * 5, // 5 minutes
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
